import { AccountSignUpAction } from '@app/store/account/sign-up/actions';
import {
  ACCOUNT_SIGN_UP_EMAIL_RESEND_FAILURE,
  ACCOUNT_SIGN_UP_EMAIL_RESEND_REQUEST,
  ACCOUNT_SIGN_UP_EMAIL_RESEND_SUCCESS,
} from '@app/store/actionTypes';

type AccountSignUpIsSignUpCheckIsFetchingState = boolean;

const initialState: AccountSignUpIsSignUpCheckIsFetchingState = false;

export default function reducer(
  state: AccountSignUpIsSignUpCheckIsFetchingState = initialState,
  action: AccountSignUpAction
) {
  switch (action.type) {
    case ACCOUNT_SIGN_UP_EMAIL_RESEND_REQUEST:
      return true;
    case ACCOUNT_SIGN_UP_EMAIL_RESEND_SUCCESS:
    case ACCOUNT_SIGN_UP_EMAIL_RESEND_FAILURE:
      return false;
    default:
      return state;
  }
}
